import { useEffect, useState, useCallback } from "react";

const TOTAL_TIME = 180; // 3 minutes in seconds

export const usePersistentCountdown = (
    key: string,
    isActive: boolean,
    onTimeout?: () => void
) => {
    const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);

    const clear = useCallback(() => {
        localStorage.removeItem(key);
    }, [key]);

    useEffect(() => {
        if (!isActive) return;

        let startTime = localStorage.getItem(key);

        if (!startTime) {
            startTime = Date.now().toString();
            localStorage.setItem(key, startTime);
        }

        const start = Number(startTime);

        const interval = window.setInterval(() => {
            const elapsed = Math.floor((Date.now() - start) / 1000);
            const remaining = Math.max(TOTAL_TIME - elapsed, 0);

            setTimeLeft(remaining);

            if (remaining === 0) {
                clear();
                onTimeout?.();
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [isActive, key, clear, onTimeout]);

    return { timeLeft, clear };
};
